import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {ListGlyph, UserGlyph} from '../glyphicons/Glyphicons';
import * as pageFunctions from '../../actions/Page';
import CreateComplaintMenuItem from './CreateComplaintMenuItem';
import textTranslates from './translate.json';
import './CreateComplaintMenu.scss';

class CreateComplaintMenu extends Component {
    
    onBtnCustomerClick = () => {
        this.props.changePageToCreateComplaintCustomer();
    }

    onBtnPositionsClick = () => {
        if (this.props.menu.selected === "btnCustomer") {
            return;
        }
        this.props.changePageToCreateComplaintPositions();
    }

    render() {
        return(
            <div className="create-complaint-menu">
                <div className="create-complaint-menu-wrapper">
                    <ul className="nav nav-pills create-complaint-menu-list">
                            <CreateComplaintMenuItem
                                completed={this.props.menu.customerCompleted}
                                name="btnCustomer"
                                onClick={this.onBtnCustomerClick}
                                selected={this.props.menu.selected ==="btnCustomer"}
                                title={textTranslates.btnCustomer.toolTip}>
                                <UserGlyph />
                            </CreateComplaintMenuItem>
                            <CreateComplaintMenuItem
                                completed={this.props.menu.positionsCompleted}
                                name="btnPositions"
                                onClick={this.onBtnPositionsClick}
                                selected={this.props.menu.selected ==="btnPositions"}
                                title={textTranslates.btnPositions.toolTip}>
                                <ListGlyph />
                            </CreateComplaintMenuItem>
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
       menu: state.createComplaintMenu
   };
};

const mapDispatchToProps = (dispatch) => {
   return {
        changePageToCreateComplaintCustomer: () => dispatch(pageFunctions.changePageToCreateComplaintCustomer()),
        changePageToCreateComplaintPositions: () => dispatch(pageFunctions.changePageToCreateComplaintPositions())
   };
};

CreateComplaintMenu.propTypes = {
    changePageToCreateComplaintCustomer: PropTypes.func,
    menu: PropTypes.object,
    changePageToCreateComplaintPositions: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateComplaintMenu);


// WEBPACK FOOTER //
// ./src/components/CreateComplaintMenu/CreateComplaintMenu.js